<template>
  <section :class="$options.name">
    <section
      v-for="(item, index) in itemsFiltered"
      :key="index"
      :class="$options.name + '__wrapper'"
    >
      <transition name="fade" mode="out-in">
        <Img
          :class="$options.name + '__item'"
          v-if="item.media_type === 'IMAGE'"
          :caption="item.caption"
          :src="item.media_url"
          :key="item.id"
        />
        <Video
          :class="$options.name + '__item'"
          v-if="item.media_type === 'VIDEO'"
          :caption="item.caption"
          :src="item.media_url"
          :key="item.id"
        />
      </transition>
      <nav v-if="arrows && itemsPaginated" :class="$options.name + '__nav'">
        <button
          :class="$options.name + '__navBtn'"
          @click="previous"
          aria-label="View previous image"
        >
          <span>
            <Icon name="arrow-left" :size="16" />
          </span>
        </button>
        <button
          :class="$options.name + '__navBtn'"
          @click="next"
          aria-label="View next image"
        >
          <span>
            <Icon name="arrow-right" :size="16" />
          </span>
        </button>
      </nav>
      <nav
        v-if="dots && itemsPaginated"
        :class="$options.name + '__pagination'"
      >
        <button
          v-for="index of itemsPaginated"
          :key="index"
          :class="[
            $options.name + '__paginationBtn',
            active === index ? $options.name + '__paginationBtn--active' : '',
          ]"
          @click="updateActive(index)"
          :aria-label="'View image ' + index"
        ></button>
      </nav>
    </section>
    <figcaption
      v-if="caption"
      :class="[$options.name + '__caption', 'Img__caption']"
    >
      <p>{{ captionStripped(caption) }}</p>
    </figcaption>
  </section>
</template>
<script>
import Icon from "@/components/Icon";
import Img from "@/components/Img";
import Video from "@/components/Video";
export default {
  name: "Carousel",
  components: { Icon, Img, Video },
  computed: {
    itemsFiltered() {
      let start = this.active * this.quantity;
      let stop = (this.active + 1) * this.quantity;
      return this.items.slice(start, stop);
    },
    itemsPaginated() {
      let pages = Math.ceil(this.items.length / this.quantity);
      let array = Array.apply(null, { length: pages }).map(Number.call, Number);
      if (array.length > 1) {
        return array;
      }
    },
  },
  data() {
    return {
      active: 0,
    };
  },
  methods: {
    captionStripped(caption) {
      let logic = new RegExp("#([^\\s]*)", "g");
      return caption.replace(logic, "");
    },
    next() {
      if (this.active < this.itemsPaginated.length - 1) {
        this.active += 1;
      } else {
        this.active = 0;
      }
    },
    previous() {
      if (this.active > 0) {
        this.active -= 1;
      } else {
        this.active = this.itemsPaginated.length - 1;
      }
    },
    updateActive(value) {
      this.active = value;
    },
  },
  props: {
    arrows: { default: true },
    dots: { default: true },
    caption: { default: null },
    items: { default: [], type: Array },
    quantity: { default: 1, type: Number },
  },
};
</script>
<style lang="scss">
.Carousel {
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  &__caption {
    width: 100%;
  }
  &__wrapper {
    position: relative;
    width: 100%;
  }
  &__nav {
    align-items: center;
    display: flex;
    justify-content: space-between;
    padding: 0 rem(8);
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 100%;
    &Btn {
      @include smooth;
      align-items: center;
      background-color: var(--base);
      border-radius: 50%;
      color: white;
      cursor: pointer;
      display: inline-flex;
      height: rem(40);
      justify-content: center;
      width: rem(40);
      [data-theme="dark"] & {
        background-color: var(--contrast);
      }
      &:focus,
      &:hover,
      &--active {
        color: var(--highlight);
      }
      span {
        @include typeFamily(secondary);
        @include typeSize(l, m);
        font-weight: bold;
        position: relative;
        top: rem(-2);
      }
    }
  }
  &__pagination {
    align-items: center;
    border-top: rem(1) solid var(--base-ghost);
    display: flex;
    flex-shrink: 0;
    height: rem(40);
    justify-content: center;
    overflow: hidden;
    width: 100%;
    &Btn {
      @include typeSize(l, s);
      background-color: var(--base);
      border: rem(8) solid var(--contrast);
      border-radius: 50%;
      cursor: pointer;
      height: rem(24);
      opacity: 0.25;
      width: rem(24);
      &:focus,
      &:hover {
        opacity: 0.5;
      }
      &--active {
        background-color: var(--highlight);
        opacity: 1;
        &:focus,
        &:hover {
          opacity: 1;
        }
      }
    }
  }
}
.fade-enter-active,
.fade-leave-active {
  @include smooth;
  transition-delay: 0.375s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
